import Modal from 'react-modal';
import React, { useState, useEffect, useContext } from 'react';

import Backend from '../../lib/Backend';
import connectProps from '../../lib/connectProps';
import SettingsContext from 'shared/lib/SettingsContext';

const SendTestForm = (props) => {
  const settings = useContext(SettingsContext);
  const [formEmails, setEmails] = useState({
    emails: '',
    selectedEmails: [],
    usedEmails: []
  })

  useEffect(()=>{
    loadUsedEmails();
  }, [])

  const loadUsedEmails = () => {
    const { send_test_url } = settings;
    const url = `${send_test_url}/used_emails.json`;
    Backend.get(url).then(usedEmails => setEmails({ ...formEmails, usedEmails }));
  }

  const newEmails = () => formEmails.emails.length > 0 ? formEmails.emails.split(',') : [];

  const handleSubmit = (event) => {
    event.preventDefault();

    const { send_test_url } = settings;

    const body = new FormData();
    const emails = newEmails().concat([...formEmails.selectedEmails])
    body.append('emails', JSON.stringify(emails));
    Backend.post(send_test_url, { body }).then(response => {
      if(response.result === 'success') {
        props.handleSuccess();
      } else {
        props.handleError(response.message);
      }
    });
  }

  const handleChange = (event) => {
    setEmails({...formEmails, emails: event.target.value});
  }

  const handleCheckBoxChange = (event) => {
    const value = event.target.value;
    const selectedEmails = new Set(formEmails.selectedEmails);
    if(selectedEmails.has(value)) {
      selectedEmails.delete(value);
    } else {
      selectedEmails.add(value);
    }
    setEmails({...formEmails, selectedEmails: [...selectedEmails]});
  }

  const submitAttrs = () => {
    if(formEmails.selectedEmails.length > 0 || formEmails.emails.length > 0) {
      return {};
    } else {
      return { disabled: 'disabled' };
    }
  }

  const renderCheckBox = (element, index) => {
    return (
      <div className="checkbox checkbox-primary" key={index}>
        <input type="checkbox" value={element} id={`email_${index}`} onChange={handleCheckBoxChange}/>
        <label htmlFor={`email_${index}`}>{element}</label>
      </div>
    );
  }

  const renderNote = () => {
    return (
      <>
        <h3>{ i18n.t('send_test.restrictions_caption') }</h3>
        <h4>{ i18n.t('send_test.restrictions_1') }</h4>
        { i18n.locale === "ru" ?
          [
            <p key='0'>{ i18n.t('send_test.restrictions_2') }</p>,
            <p key='1'>{ i18n.t('send_test.restrictions_2_1') }</p>,
          ] : <p>{ i18n.t('send_test.restrictions_2') }</p>
        }
        <h4>{ i18n.t('send_test.restrictions_3') }</h4>
        <p>{ i18n.t('send_test.restrictions_4') }</p>
        <p>{ i18n.t('send_test.restrictions_5') }</p>
      </>
    );
  }

  return (
    <div className="row">
      <div className="col-sm-6">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>{ i18n.t('send_test.label') }</label>
            <input type="text" className="form-control" value={formEmails.emails} onChange={handleChange} />
          </div>
          <div className="form-group">
            {formEmails.usedEmails.map((element, index) => renderCheckBox(element, index))}
          </div>
          <div className="form-group">
            <input type="submit" value={ i18n.t('send_test.send') } className="btn btn-success" {...submitAttrs()} />
          </div>
        </form>
      </div>
      <div className="col-sm-6">
        {renderNote()}
      </div>
    </div>
  );
}

export default SendTestForm;
